export default __webpack_public_path__ + "static/media/subs-angle-icon.a8c53678.svg";